import superagent from 'superagent';
import * as c from '../constants/actionTypes';
import * as config from '../config/config';



const POST_PAYSTRIPE_REQUEST = 'POST_PAYSTRIPE_REQUEST'
const POST_PAYSTRIPE_SUCCESS = 'POST_PAYSTRIPE_SUCCESS'
const POST_PAYSTRIPE_FAILURE = 'POST_PAYSTRIPE_FAILURE'
export {
  POST_PAYSTRIPE_REQUEST,
  POST_PAYSTRIPE_SUCCESS,
  POST_PAYSTRIPE_FAILURE
}

export function postPayStripeRequest() {
  return {
    type: POST_PAYSTRIPE_REQUEST,
    loading: true
  }
}

export function postPayStripeSuccess(body) {
  return {
    type: POST_PAYSTRIPE_SUCCESS,
    body: body,
    loading: false
  }
}

export function postPayStripeFailure(error) {
  return {
    type: POST_PAYSTRIPE_FAILURE,
    error: error,
    loading: false
  }
}

const POST_PAY_STRIPE = 'POST_PAY_STRIPE';
export { POST_PAY_STRIPE }

export function postPayStripe(payData, cb) {
  return function(dispatch) {
    dispatch(postPayStripeRequest())
    superagent
    .post(config.BASE + 'api/stripe')
    .send(payData)
    .withCredentials()
    .end((err, res) => {
      if (err) {
        cb(false);
        alert("There was a problem processing your payment! Please try again or contact us at info@editmypaper.ca");
        dispatch(postPayStripeFailure(err))
      } else {
        dispatch(postPayStripeSuccess(res.body))
        cb(true);
      }
    })
  }
}

export function BothEmailsMatch(body){
  return {
    type: c.BOTH_EMAILS_MATCH,
    loading: false,
    body: body
  }
}
export function BothEmailsDontMatch(body){
  return {
    type: c.BOTH_EMAILS_DONT_MATCH,
    loading: false,
    body: body
  }
}

export function TermsAreChecked(body){
  return {
    type: c.TERMS_CHECKED,
    loading: false,
    body: body
  }
}

export function getPricing_Success(body){
  return {
    type: c.GET_PRICING_SUCCESS,
    loading: false,
    body: body
  }
}
export function PaypalPaymentAuthorized(body){
  return {
    type: "AUTHORIZED_PAYPAL",
    body: body,
    loading: false
  }
}


export function PaypalPaidSuccessFailure(payment){
  return {
    type: "PAY_WITH_PAYPAL_FAIL",
    loading: false,
    body: payment
  }
}

export function PaypalPaidSuccess(send_ob, cb){
  return function(dispatch) {
    // dispatch(getPricing_Request())
    superagent
    .post(config.BASE + 'api/paypal')
    .set('Content-Type', 'application/json')
    .withCredentials()
    .send(send_ob)
    .end((err, res) => {
      if (err) {
        cb(false);
        alert("Your paypal payment has been accepted, but we had an issue finalizing the operation. Please contact us at info@editmypaper.ca");
        dispatch(PaypalPaidSuccessFailure(err))
      } else {
        dispatch(PaypalPaymentAuthorized(res.body))
        cb(true);
      }
    })
  }
}

export function updateBalanceUsed(balanceUsed){
  return {
    type: "UPDATE_BALANCE_USED",
    body: balanceUsed
  }
}

export function updateBalanceUsedSuccess(balanceUsed){
  return {
    type: "UPDATE_BALANCE_USED_SUCCESS",
    body: balanceUsed
  }
}
export function updateBalanceUsedFailure(balanceUsed){
  return {
    type: "UPDATE_BALANCE_USED_FAILURE",
    body: balanceUsed
  }
}

export function updateCouponCode(body){
  return {
    type: "UPDATE_COUPON_CODE",
    body: body
  }
}

export function CheckCouponSuccess(body){
  return {
    type: "CHECK_COUPON_SUCCESS",
    body: body
  }
}
export function CheckCouponFailure(body){
  return {
    type: "CHECK_COUPON_FAILURE"
  }
}
export function CheckCouponRequest(body){
  return {
    type: "CHECK_COUPON_REQUEST"
  }
}

export function CheckCoupon(body, cb){
  return function(dispatch) {
    dispatch(CheckCouponRequest())
    console.log("Check coupon action ");
    console.log(body);
    superagent
    .post(config.BASE + 'api/affiliate_code')
    .withCredentials()
    .send({body: body})
    .end((err, res) => {
      if (err) {
        console.log("Error   ---------> " + JSON.stringify(err))
        dispatch(CheckCouponFailure(err))
        cb({is_affiliate: false, amount: false, msg: res.body.msg});
        //alert(res.body.msg);
      } else {
        if(res.body.coupon_status === "ACTIVE"){
          if(res.body.coupon.is_affiliate == true) {
            cb({is_affiliate: true, amount: res.body.coupon.coupon_amount, msg: ""});
            //alert("You have received a discount of $"+res.body.coupon.coupon_amount+" because your friend referred you. It has been already deducted from your order.");
          } else {
            cb({is_affiliate: false, amount: res.body.coupon.coupon_amount, msg: ""});
            //alert("This coupon is valid! You have saved $" + res.body.coupon.coupon_amount + " off the cost of your edit.");
          }
        }else if (res.body.coupon_status === "INACTIVE") {
          cb({is_affiliate: false, amount: false, msg: res.body.msg});
          //alert(res.body.msg);
        }
        dispatch(CheckCouponSuccess(res.body));
      }
    })
  }
}

export function getPricing(){
  return function(dispatch) {
    // dispatch(getPricing_Request())
    console.log("Get pricing aciton ");
    superagent
    .get(config.BASE + 'api/pricing')
    .end((err, res) => {
      if (err) {
        console.log("Error   ---------> " + JSON.stringify(err))
        // dispatch(getPricing_Failure(err))
      } else {
        console.log("<----< Get Pricing >---->");
        dispatch(getPricing_Success(res.body));
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/pay.js